import { useEffect, useState } from "react";
import { Plus, Check, Loader2 } from "lucide-react";
import api from "../../../lib/api";
import { formatPrice } from "../../../lib/formatPrice";
import { useLabBooking } from "../context/LabBookingContext";

const PopularPackagesRail = () => {
  const { addTest, removeTest, isTestSelected } = useLabBooking();
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    setError(null);
    api
      .post("/user/lab/master-package", { page: 1 })
      .then((res) => setPackages(res.data?.data?.items || []))
      .catch(() => setError("Couldn't load packages."))
      .finally(() => setLoading(false));
  }, []);

  const toSelectionItem = (pkg) => ({
    name: pkg.name,
    test_count: pkg.test_count,
    is_package: 1,
    from_price: pkg.from_price,
    lab_name: pkg.lab_name,
  });

  return (
    <div>
      <h3 className="text-[13px] font-bold text-[#191C1D] mb-2">
        Popular Health Packages
      </h3>

      {loading && (
        <div className="flex items-center gap-2 text-[12px] text-[#6B7A99] py-4">
          <Loader2 size={14} className="animate-spin" /> Loading...
        </div>
      )}
      {!loading && error && (
        <p className="text-[12px] text-red-500 py-2">{error}</p>
      )}

      <div className="space-y-2 max-h-[320px] overflow-y-auto pr-1">
        {!loading &&
          !error &&
          packages.map((pkg) => {
            const item = toSelectionItem(pkg);
            const selected = isTestSelected(item);
            return (
              <div
                key={`${pkg.id}-${pkg.lab_id}`}
                className="bg-white rounded-xl border border-gray-100 p-2.5"
              >
                <p className="text-[12px] font-bold text-[#191C1D]">
                  {pkg.name}
                </p>
                {!!pkg.test_count && (
                  <p className="text-[10px] text-[#6B7A99]">
                    {pkg.test_count} Tests Included
                  </p>
                )}
                {pkg.package_category && (
                  <span className="inline-block text-[9px] px-1.5 py-0.5 rounded-full bg-[#EEF3F2] text-[#13B58E] font-medium mt-1.5">
                    {pkg.package_category}
                  </span>
                )}
                <div className="flex items-center justify-between mt-2">
                  <span className="text-[14px] font-extrabold text-[#191C1D]">
                    ₹{formatPrice(pkg.from_price)}
                  </span>
                  <button
                    onClick={() => (selected ? removeTest(item) : addTest(item))}
                    className={`flex items-center gap-1 text-[11px] font-semibold px-3 py-1 rounded-full transition ${
                      selected
                        ? "bg-[#EEF3F2] text-[#13B58E]"
                        : "bg-[#13B58E] text-white hover:bg-[#0fa07d]"
                    }`}
                  >
                    {selected ? (
                      <>
                        <Check size={11} /> Added
                      </>
                    ) : (
                      <>
                        <Plus size={11} /> Add
                      </>
                    )}
                  </button>
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default PopularPackagesRail;
